import { useEffect as u } from "react";
const i = ({
  target: e,
  callback: t,
  options: o,
  dependencies: s = [],
  enabled: c = !0
}) => {
  u(() => {
    if (!c)
      return;
    const r = new IntersectionObserver((n) => {
      n[0] && t(n[0]);
    }, o);
    return e.current && r.observe(e.current), () => r.disconnect();
  }, [s]);
};
export {
  i as useIntersectionObserver
};
